import React from 'react';
import SciqusLogo from '../../assest/group7.png'
import Image1 from '../../assest/dashboard.png'
import './whatissciqusams.scss'

const WhatIsSciqusams = () => {
	return (
		<>
			<div id="whatams" className="mainWhatIsSciqusams">
				<div className="subWhatIsSciqusams">
					<div className="WhatIsSciqusams">
						<div className="WhatIsSciqusamsData">
							<div className="subWhatIsSciqusamsData">
								<div className="LeftSideTitle">
									<h2>What Is</h2>
									<img src={SciqusLogo} alt=""/>
									<h2>?</h2>
								</div>
								<div className="LeftSideContent">
									<p>We are the world’s first AI-powered End-to-End Customer Success Platform. Sciqus AMS helps businesses retain and grow customers by centralizing customer intelligence through Customer 360+ and streamlining renewals and expansion workflows. By providing clear insights into client health, account activity, and financial data, Sciqus AMS enables teams to reduce churn and drive sustainable revenue growth.</p>
								</div>
							</div>
						</div>
						<div className="WhatIsSciqusamsDataImage">
							<div className="RightSideImage">
								<img src={Image1} alt=""/>
							</div>
						</div>
					</div>
					<div className="Customer360">
						<h1>Customer 360+ Intelligence Hub</h1>
					</div>
				</div>
			</div>
		</>
	);
};

export default WhatIsSciqusams;